/* Rosterpress team bundle UI — runs inside Dawn's main-product section.
   Reads #rp-bundle-data (one product with Style × Color × Size variants), fills the rp_* blocks and the gallery,
   and adds the whole bundle via /cart/add.js. If anything fails before the first render, the Dawn page is restored. */
(function () {
  'use strict';

  function fallbackToDawn(scope) {
    var hide = document.getElementById('rp-hide-main');
    if (hide) hide.remove();
    (scope || document).querySelectorAll('.rp-bundle').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.rp-bar-holder').forEach(function (el) { el.remove(); });
    document.body.classList.remove('rp-has-bar');
  }

  function start() {
    var dataEl = document.getElementById('rp-bundle-data');
    if (!dataEl) return;
    var scope = dataEl.closest('section') || document;
    if (scope.__rpBooted) return;
    scope.__rpBooted = true;
    try { boot(scope, dataEl); } catch (e) { fallbackToDawn(scope); if (window.console) console.error('[rp-bundle]', e); }
  }

  function boot(scope, dataEl) {
    if (!window.RPBundleCore) throw new Error('core missing');
    var C = window.RPBundleCore;
    var D = JSON.parse(dataEl.textContent);
    var R = D.rules;
    var VARIANTS = D.variants.filter(function (v) { return v && v.id; });
    var STYLES = D.styles.filter(function (st) { return VARIANTS.some(function (v) { return v.style === st; }); });
    var COLORS = D.colors || [];
    var SIZES = D.sizes;
    /* single listings: mode "fit" (the Fit option sits in the style slot) or "fixed" (one garment, no picker) */
    var PM = C.pickerMode(D);
    if (!STYLES.length || !SIZES.length) throw new Error('no styles');
    if (!scope.querySelector('[data-rp=cards]') || !scope.querySelector('[data-rp=cta]')) throw new Error('builder or summary block missing');

    var KEY = 'rp-bundle:' + D.product.handle;
    // default garment (owner 30/09): Bowling Jersey when the listing sells it, unless the shopper arrived on a specific ?variant=
    var firstStyle = STYLES.indexOf(D.current.style) >= 0 && /[?&]variant=/.test(location.search) ? D.current.style
      : STYLES.indexOf('Bowling Jersey') >= 0 ? 'Bowling Jersey' : STYLES.indexOf(D.current.style) >= 0 ? D.current.style : STYLES[0];
    var firstColor = COLORS.some(function (c) { return c.name === D.current.color; }) ? D.current.color : (COLORS[0] ? COLORS[0].name : '');
    var I_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9" fill="none" stroke="#fff" stroke-width="2.6"/></svg>';
    var I_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h18v4H3zM5 13h14v8H5zM12 9v12M12 9C10 5 6 5 6 8s4 1 6 1c2 0 6 2 6-1s-4-3-6 1" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';
    var I_CART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11h11l2-8H7" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="9" cy="19.5" r="1.6" fill="currentColor"/><circle cx="17" cy="19.5" r="1.6" fill="currentColor"/></svg>';

    /* The sticky bar must live directly under <body>: Dawn animates the product column with a transform,
       and position:fixed inside a transformed ancestor stops sticking to the viewport. */
    var barHolder = null;
    var barEl = scope.querySelector('.rp-bar');
    document.querySelectorAll('.rp-bar-holder').forEach(function (el) { el.remove(); });
    if (barEl) {
      barHolder = document.createElement('div');
      barHolder.className = 'rp-bundle rp-block rp-bar-holder';
      barHolder.appendChild(barEl);
      document.body.appendChild(barHolder);
    }
    var ROOTS = barHolder ? [scope, barHolder] : [scope];
    /* "Design Your Own" products (block rp_designer): the shopper picks a library design first (rp-designer.js),
       it replaces the product photos, carries its name/team boxes, and travels on every shirt line. */
    var DYO = !!scope.querySelector('[data-rp=dyo]');
    /* Library products (custom.library metafield): our own 3:2 renders, name/team boxes per style, measured tone. */
    var LIB = (!DYO && D.library && D.library.boxes) ? D.library : null;
    /* our own designs print the sport's icon above the name (the DEV SAMPLE photos already have one printed) */
    var ICON = (LIB || DYO) ? C.SPORT_ICONS[C.sportOf(D.tags)] : null;
    var LIGHT = ['white', 'silver', 'gold', 'neon'];
    var AUTO = { id: 'auto', label: 'Auto' };
    var I_PEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20l4-1 11-11-3-3L5 16l-1 4zM14 6l3 3" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>';
    /* library photos are square (front big + back behind); a design without its square photo yet shows the 3:2 render whole */
    function syncWide() {
      var wide = (DYO && S.design && !S.design.square) || (LIB && LIB.aspect && LIB.aspect !== 1);
      document.body.classList.toggle('rp-wide-page', !!wide);
    }

    function one(hook) { return scope.querySelector('[data-rp=' + hook + ']'); }
    function all(hook) {
      var out = [];
      ROOTS.forEach(function (r) { out = out.concat(Array.prototype.slice.call(r.querySelectorAll('[data-rp=' + hook + ']'))); });
      return out;
    }
    function set(hook, html) { all(hook).forEach(function (el) { el.innerHTML = html; }); }
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function blank(style, color) { return { style: style, color: color, size: '', pers: true, name: '', team: '' }; }
    function validColor(c) { return !COLORS.length || COLORS.some(function (x) { return x.name === c; }); }
    function validTextColor(c) { return !!c && typeof c.id === 'string' && typeof c.label === 'string'; }
    function validDesign(d) {
      var cdn = /^https:\/\/cdn\.shopify\.com\//;
      return !!d && typeof d.sku === 'string' && d.sku.length > 0 && typeof d.image === 'string' && cdn.test(d.image) &&
        (!d.square || (cdn.test(d.square) && !!d.squareBoxes)) && validTextColor(d.nameColor) && validTextColor(d.teamColor);
    }

    function load() {
      try {
        var v = JSON.parse(sessionStorage.getItem(KEY));
        if (v && Array.isArray(v.shirts) && v.shirts.length) {
          v.shirts.forEach(function (s) {
            if (STYLES.indexOf(s.style) < 0) s.style = firstStyle;
            if (!validColor(s.color)) s.color = firstColor;
          });
          return { active: 0, view: 0, protect: false, shirts: v.shirts, busy: false, error: '', design: DYO && validDesign(v.design) ? v.design : null };
        }
      } catch (e) {}
      return null;
    }
    var S = load() || { active: 0, view: 0, protect: false, shirts: [blank(firstStyle, firstColor), blank(firstStyle, firstColor)], busy: false, error: '', design: null };
    S.showErrors = false;
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify({ shirts: S.shirts, protect: S.protect, design: S.design })); } catch (e) {} }

    function find(style, color, size) {
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i];
        if (v.style === style && (!COLORS.length || v.color === color) && (size == null || v.size === size)) return v;
      }
      return null;
    }
    function variantOf(s) { return s.size ? find(s.style, s.color, s.size) : null; }
    function priceOf(s) { var v = variantOf(s) || find(s.style, s.color, SIZES[0]) || find(s.style, s.color); return v ? v.price : 0; }
    function fromPrice(style) { var min = Infinity; VARIANTS.forEach(function (v) { if (v.style === style && v.price < min) min = v.price; }); return min; }
    function missing(s) { var v = variantOf(s); return !v || !v.available; }
    function calc() { return C.calc(S.shirts.map(function (s) { return { price: priceOf(s), pers: C.personalized(s) }; }), R, S.protect); }
    function sized(url, w) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
    function imgOf(s) {
      if (DYO && S.design) return sized(S.design.square || S.design.image, 1200);
      var v = find(s.style, s.color); return (v && v.image) || D.images[0] || '';
    }
    function galleryOf(s) {
      var main = imgOf(s), list = [main];
      if (DYO && S.design) return list;  // the other product photos are sample designs, not the shopper's
      D.images.forEach(function (u) { if (list.length < 6 && u !== main) list.push(u); });
      return list;
    }

    var gradN = 0;
    function textPaint(col, dark) {
      if (col.metallic) {
        var id = 'rp-metal-' + (++gradN);
        var stops = C.cssStops(col.fill).map(function (st) { return '<stop offset="' + st.offset + '%" stop-color="' + esc(st.color) + '"/>'; }).join('');
        return { defs: '<linearGradient id="' + id + '" x1="0" y1="0" x2="0" y2="1">' + stops + '</linearGradient>', fill: 'url(#' + id + ')', stroke: 'rgba(0,0,0,.55)' };
      }
      if (col.id === 'design') return { defs: '', fill: col.fill, stroke: col.outline || 'rgba(0,0,0,.55)', sw: col.sw, font: col.font, cw: col.cw, fw: col.fw };  // per-design lettering (custom.library.text)
      if (col.id === 'auto') return { defs: '', fill: dark ? '#111' : '#fff', stroke: dark ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.55)' };
      return { defs: '', fill: col.fill || '#fff', stroke: LIGHT.indexOf(col.id) >= 0 ? 'rgba(0,0,0,.6)' : 'rgba(255,255,255,.75)' };
    }
    /* name / team name on a 3:2 library render: the chosen design (studio colours) or a library product (Auto colour) */
    function designOverlay(s) {
      var d = S.design;
      if (!d) return '';
      if (d.square) return boxOverlay(s, d.squareBoxes, d.nameColor, d.teamColor, d.dark || {}, 1);
      return d.boxes ? boxOverlay(s, d.boxes, d.nameColor, d.teamColor, d.dark || {}, 1.5) : '';
    }
    function libraryOverlay(s) {
      var sk = C.styleKey(LIB.boxes, s.style, D), boxes = C.libraryBoxes(LIB, sk), tx = LIB.text || {};
      /* text.outlines = outline per shirt colour (cloned listings: black letters, outline in the colourway's accent) */
      var col = function (k) { var t = tx[k]; return t ? { id: 'design', fill: t.fill, outline: (tx.outlines && tx.outlines[s.color]) || t.outline, sw: t.sw, font: tx.font, cw: tx.cw, fw: tx.fw } : AUTO; };
      return boxes ? boxOverlay(s, boxes, col('name'), col('team'), C.libraryTone(LIB, sk, s.color), LIB.aspect || 1.5) : '';
    }
    function boxOverlay(s, boxes, nameColor, teamColor, dark, aspect) {
      var pt = C.previewText(s);
      if (!pt || !boxes) return '';
      var DH = 1000, DW = Math.round(1000 * aspect);
      var defs = '', g = '';
      [['name', pt.name, nameColor], ['team', pt.team, teamColor]].forEach(function (p) {
        var b = boxes[p[0]], txt = p[1];
        if (!b || !txt) return;
        var geo = null, paint = textPaint(p[2], !!dark[p[0]]);
        geo = C.overlayGeom(b, p[0] === 'team' ? C.teamLines(txt) : txt, DW, DH, paint.cw);
        defs += paint.defs;
        geo.lines.forEach(function (line, k) {  // long team names: 2 lines stacked around the box centre
          var y = geo.y - geo.lh * (geo.lines.length - 1) / 2 + geo.lh * k + geo.fs * 0.35;
          g += '<text x="' + geo.x.toFixed(1) + '" y="' + y.toFixed(1) + '" text-anchor="middle" font-family="' + esc(paint.font || 'Barlow Condensed, Arial Narrow, sans-serif') + '" font-weight="' + (paint.fw || 800) + '"' +
            ' font-size="' + geo.fs.toFixed(1) + '" fill="' + esc(paint.fill) + '" stroke="' + esc(paint.stroke) + '" stroke-width="' + (geo.fs * (paint.sw || 0.06)).toFixed(1) + '" paint-order="stroke" stroke-linejoin="round">' + esc(line) + '</text>';
        });
      });
      if (ICON && pt.name && boxes.name && !(LIB && LIB.noIcon)) {  // the sport icon, in the name's colour, just above it
        var ig = C.iconGeom(boxes.name, DW, DH), ip = textPaint(nameColor, !!dark.name);
        defs += ip.defs;
        g += '<g transform="translate(' + ig.x.toFixed(1) + ' ' + ig.y.toFixed(1) + ') scale(' + (ig.size / 100).toFixed(4) + ')" fill="' + esc(ip.fill) +
          '" stroke="' + ip.stroke + '" stroke-width="3" paint-order="stroke" stroke-linejoin="round">' + ICON.svg + '</g>';
      }
      return g ? '<svg viewBox="0 0 ' + DW + ' ' + DH + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + (defs ? '<defs>' + defs + '</defs>' : '') + g + '</svg>' : '';
    }

    function fitFont(txt, w, fs) { var est = txt.length * 0.5 * fs; return est > w * 1.05 ? Math.max(9, fs * w * 1.05 / est) : fs; }
    function overlay(s) {
      if (DYO) return designOverlay(s);
      if (LIB) return libraryOverlay(s);
      var o = (D.overlay || {})[C.styleKey(D.overlay, s.style, D)];
      var pt = C.previewText(s);
      if (!o || !pt) return '';
      var g = '';
      [['name', pt.name], ['team', pt.team]].forEach(function (pair) {
        var b = o[pair[0]], txt = pair[1];
        if (!b || !txt) return;
        var lines = pair[0] === 'team' ? C.teamLines(txt) : [txt];
        var longest = lines.reduce(function (m, l) { return l.length > m.length ? l : m; }, '');
        var fs = fitFont(longest, b.w, (b.fs || b.h * 0.8) / (1 + (lines.length - 1) * 1.05)), lh = fs * 1.05;
        g += '<rect x="' + (b.x - b.w / 2 - 4) + '" y="' + (b.y - b.h / 2 - 2) + '" width="' + (b.w + 8) + '" height="' + (b.h + 4) + '" fill="' + esc(b.bg || '#101010') + '"/>';
        lines.forEach(function (line, k) {
          var y = b.y - lh * (lines.length - 1) / 2 + lh * k + fs * 0.36;
          g += '<text x="' + b.x + '" y="' + y.toFixed(1) + '" text-anchor="middle" font-family="Barlow Condensed, Arial Narrow, sans-serif" font-weight="800" font-size="' + fs.toFixed(1) + '" fill="' + esc(b.color || '#fff') + '">' + esc(line) + '</text>';
        });
      });
      return g ? '<svg viewBox="0 0 1000 1000" preserveAspectRatio="none" aria-hidden="true">' + g + '</svg>' : '';
    }
    function shot(src, s, alt) {
      return '<span class="rp-shot"><img src="' + esc(src) + '" alt="' + esc(alt || '') + '" loading="lazy" draggable="false" width="1000" height="1000">' + (s ? overlay(s) : '') + '</span>';
    }

    function renderGallery(enterFrom) {
      if (!one('gal')) return;
      var s = S.shirts[S.active] || S.shirts[0], imgs = galleryOf(s);
      var i = Math.min(S.view || 0, Math.max(imgs.length - 1, 0));
      set('gal', shot(imgs[i] || '', i === 0 ? s : null, (PM.mode === 'fit' ? D.garment + ', ' + s.style : s.style) + (s.color ? ' · ' + s.color : '')));
      if (enterFrom) {  // swipe: the new photo slides in from the side it was pulled from
        var g = one('gal');
        g.classList.remove('rp-enter-l', 'rp-enter-r');
        void g.offsetWidth;
        g.classList.add(enterFrom < 0 ? 'rp-enter-l' : 'rp-enter-r');
      }
      set('thumbs', imgs.map(function (src, k) {
        return '<button type="button" class="rp-thumb" data-act="view" data-v="' + k + '" aria-current="' + (k === i) + '" aria-label="Photo ' + (k + 1) + '">' + shot(src, null, '') + '</button>';
      }).join(''));
      set('dots', imgs.map(function (_, k) { return '<i class="' + (k === i ? 'rp-on' : '') + '"></i>'; }).join(''));
    }

    function teamColor() {
      var c = S.shirts[0].color;
      return S.shirts.every(function (s) { return s.color === c; }) ? c : '';
    }
    function renderPrice() {
      var one_ = fromPrice(STYLES[0]);
      set('price', (PM.mode !== 'style' && D.garment ? '<p class="rp-garment">' + esc(D.garment) + '</p>' : '') + '<b>' + money(one_ - R.off_each) + '</b><s>' + money(one_) + '</s><span class="rp-save">Save ' + Math.round(R.off_each / one_ * 100) + '%</span>');
      var tc = teamColor();
      set('swatches', COLORS.length > 1 ? '<span class="rp-swatch-label">Team colour</span>' + COLORS.map(function (c) {
        return '<button type="button" class="rp-swatch" data-act="teamcolor" data-v="' + esc(c.name) + '" aria-pressed="' + (c.name === tc) + '"><i style="background:' + esc(c.swatch || '#ccc') + '"></i>' + esc(c.name) + '</button>';
      }).join('') : '');
    }

    function renderOffers() {
      if (!one('offers')) return;
      var c = calc(), base = fromPrice(STYLES[0]);
      var tiers = (D.tiers || []).filter(function (t) { return t.n >= 1 && t.n <= R.max; });
      function icon(red) { return '<svg viewBox="0 0 26 28" aria-hidden="true"><path d="M7 2 L11 1 Q13 3 15 1 L19 2 L25 7 L22 12 L20 11 L20 27 L6 27 L6 11 L4 12 L1 7 Z" fill="' + (red ? '#F43636' : '#10161D') + '" stroke="#fff" stroke-width="1.2"/></svg>'; }
      set('offers', tiers.map(function (t) {
        var prices = []; for (var k = 0; k < t.n; k++) prices.push(base);
        var r = C.priceFor(prices, R), pay = r.base - r.disc, pct = Math.round(r.disc / r.base * 100);
        var title = t.n === 1 ? 'Buy 1' : (r.freeN ? 'Buy ' + (t.n - r.freeN) + ' Get ' + r.freeN + ' Free' : t.n + ' Shirts');
        var icons = ''; for (var j = 0; j < t.n; j++) icons += icon(r.freeN > 0 && j >= t.n - r.freeN);
        return '<button type="button" class="rp-offer" data-act="tier" data-n="' + t.n + '" aria-pressed="' + (c.n === t.n) + '">' +
          (t.ribbon ? '<span class="rp-ribbon' + (t.gold ? ' rp-gold' : '') + '">' + esc(t.ribbon) + '</span>' : '') +
          '<span class="rp-icons">' + icons + '</span><span class="rp-ot">' + title + '</span>' +
          '<span class="rp-oe">' + (t.n === 1 ? '1 shirt' : t.n + ' shirts · ' + money(pay / t.n) + ' each') + '</span>' +
          '<span class="rp-op">' + money(pay) + '<s>' + money(r.base) + '</s></span>' +
          '<span class="rp-os">Save ' + pct + '%' + (t.n >= R.free_ship_at ? ' + free shipping' : '') + '</span><span class="rp-radio" aria-hidden="true"></span></button>';
      }).join(''));
    }

    function headHTML(i, c) {
      var s = S.shirts[i], fr = c.free.has(i), m = missing(s), p = priceOf(s), sp = C.shirtPrice(i, c, p, R);
      var ico = fr ? '<span class="rp-ci rp-gift">' + I_GIFT + '</span>' : m ? '<span class="rp-ci">' + (i + 1) + '</span>' : '<span class="rp-ci rp-ok">' + I_CHECK + '</span>';
      var sub = m ? 'Pick a size to finish this shirt' : fr ? 'Your free custom shirt' : 'Your custom shirt';
      return ico + '<span><b>' + (fr ? 'Free ' : '') + 'Shirt ' + (i + 1) + '</b><small>' + sub + '</small></span>' +
        '<span class="rp-cp">' + (sp < p ? '<s>' + money(p) + '</s>' + money(sp) : money(p)) + '</span>';
    }
    function sizeButtons(i, s) {
      return SIZES.map(function (z) {
        var v = find(s.style, s.color, z), off = !v || !v.available;
        return '<button type="button" class="rp-sz" data-act="size" data-i="' + i + '" data-v="' + esc(z) + '" aria-pressed="' + (s.size === z) + '"' + (off ? ' disabled aria-disabled="true" title="Sold out"' : '') + '>' + esc(z) + '</button>';
      }).join('');
    }
    /* size-chart button: merged products name the Style; single listings name the garment type (+ the shirt's Fit) */
    function scAttrs(s) {
      if (PM.mode === 'style') return 'data-sc-style="' + esc(s.style) + '"';
      return 'data-sc-type="' + esc(D.sc_type) + '"' + (PM.mode === 'fit' ? ' data-sc-fit="' + esc(s.style) + '"' : '');
    }
    /* personalization fee on the shirt card: charged once a name or team is typed (C.personalized) */
    function persFeeText(s) {
      if (!s.pers) return '';
      return C.personalized(s) ? '+' + money(R.pers_price) + ' · printed on this shirt' : 'Add a name or team (+' + money(R.pers_price) + ')';
    }
    function renderCards() {
      var c = calc(), h = one('bundle-h');
      if (h) h.textContent = (h.getAttribute('data-heading') || 'Customize Your Bundle') + ' (' + c.n + ' Shirt' + (c.n > 1 ? 's' : '') + ')';
      set('cards', S.shirts.map(function (s, i) {
        var m = missing(s), fr = c.free.has(i), bad = m && S.showErrors;
        return '<article class="rp-card ' + (fr ? 'rp-free ' : '') + (m ? 'rp-todo ' : '') + (bad ? 'rp-invalid' : '') + '" id="rp-card-' + i + '">' +
          '<div class="rp-ch" id="rp-ch-' + i + '">' + headHTML(i, c) + '</div>' +
          '<div class="rp-cb"><button type="button" class="rp-plain" data-act="focus" data-i="' + i + '" aria-label="Preview shirt ' + (i + 1) + '" id="rp-ct-' + i + '">' + shot(imgOf(s), s, '') + '</button>' +
          '<div class="rp-cf">' +
          (PM.show ? '<div class="rp-f"><label for="rp-sty-' + i + '">' + esc(PM.label) + '</label><select class="rp-sel" id="rp-sty-' + i + '" data-act="style" data-i="' + i + '">' +
          STYLES.map(function (st) { return '<option value="' + esc(st) + '"' + (s.style === st ? ' selected' : '') + '>' + esc(st) + '</option>'; }).join('') + '</select></div>' : '') +
          (COLORS.length > 1 ? '<div class="rp-f"><label for="rp-col-' + i + '">Color</label><select class="rp-sel" id="rp-col-' + i + '" data-act="color" data-i="' + i + '">' +
            COLORS.map(function (col) { return '<option value="' + esc(col.name) + '"' + (s.color === col.name ? ' selected' : '') + '>' + esc(col.name) + '</option>'; }).join('') + '</select></div>' : '') +
          '</div></div>' +
          '<div class="rp-f"><div class="rp-lab-row"><span class="rp-lab" id="rp-szl-' + i + '">Size</span>' +
          '<button type="button" class="rp-sc-open" ' + scAttrs(s) + ' aria-label="Size chart for ' + esc(PM.mode === 'style' ? s.style : PM.mode === 'fit' ? D.garment + ', ' + s.style : D.garment) + '">Size chart</button></div>' +
          '<div class="rp-sizes ' + (bad ? 'rp-bad' : '') + '" role="group" aria-labelledby="rp-szl-' + i + '"' + (bad ? ' aria-describedby="rp-sze-' + i + '"' : '') + ' id="rp-size-' + i + '">' + sizeButtons(i, s) + '</div>' +
          (bad ? '<span class="rp-field-error" id="rp-sze-' + i + '" role="alert">Please choose a size for shirt ' + (i + 1) + '.</span>' : '') + '</div>' +
          '<div class="rp-cf2"><label class="rp-ptg" for="rp-pers-' + i + '"><span>Add name &amp; team name <b>+' + money(R.pers_price) + '</b><small>' + (s.pers ? 'Printed on this shirt' : 'Plain design, no custom text') + '</small></span>' +
          '<input type="checkbox" class="rp-tg" id="rp-pers-' + i + '" data-act="pers" data-i="' + i + '"' + (s.pers ? ' checked' : '') + '></label>' +
          (s.pers ? '<div class="rp-r2">' +
            '<div class="rp-f"><label for="rp-name-' + i + '">Name <small>(optional)</small></label><input class="rp-inp" id="rp-name-' + i + '" data-act="name" data-i="' + i + '" maxlength="20" value="' + esc(s.name) + '" placeholder="Your name" autocomplete="off" autocapitalize="characters" autocorrect="off" spellcheck="false"></div>' +
            '<div class="rp-f"><label for="rp-team-' + i + '">Team Name <small>(optional)</small></label><input class="rp-inp" id="rp-team-' + i + '" data-act="team" data-i="' + i + '" value="' + esc(s.team) + '" placeholder="Team name" autocomplete="off" autocapitalize="characters" autocorrect="off" spellcheck="false"></div></div>' +
            '<p class="rp-pfee" id="rp-pfee-' + i + '">' + persFeeText(s) + '</p>' +
            '<p class="rp-tnote"><b>Long team name?</b> Add a comma where you want line 2 to start. It looks better on 2 lines, e.g. <code>PIN PALS, BOWLING CLUB</code></p>' : '') +
          '</div><div class="rp-cfoot"><span></span><span>' +
          (i > 0 ? '<button type="button" class="rp-lnk" data-act="copy" data-i="' + i + '">Copy from Shirt 1</button>' : '') +
          (S.shirts.length > 1 ? ' &nbsp;<button type="button" class="rp-lnk" data-act="remove" data-i="' + i + '">Remove</button>' : '') +
          '</span></div></article>';
      }).join(''));
      var nf = C.nextFree(c.n, R);
      set('after', nf && nf.k === 1
        ? '<div class="rp-nudge"><span><b>Your next shirt is FREE</b><span>Add shirt ' + (c.n + 1) + ' for a teammate — Buy 1 Get 1 applies automatically.</span></span><button type="button" class="rp-btn-red" data-act="add" data-n="1">Add free shirt</button></div>'
        : nf ? '<div class="rp-nudge"><span><b>Add ' + nf.k + ' more, get ' + nf.more + ' free</b><span>' + (c.n + nf.k) + ' shirts for your team.</span></span><button type="button" class="rp-btn-red" data-act="add" data-n="' + nf.k + '">Add ' + nf.k + ' shirts</button></div>'
        : c.n < R.max ? '<button type="button" class="rp-addmore" data-act="add" data-n="1">+ Add another shirt</button>' : '');
    }

    function renderPreview() {
      if (!one('bp-shots')) return;
      var c = calc();
      set('bp-shots', S.shirts.map(function (s, i) {
        return '<button type="button" class="rp-plain" data-act="focus" data-i="' + i + '" aria-label="Preview shirt ' + (i + 1) + '">' + shot(imgOf(s), s, '') + '</button>';
      }).join(''));
      all('bp-msg').forEach(function (el) { el.textContent = c.freeN ? c.n + ' custom shirts, ' + c.freeN + ' of them free.' : c.n === 1 ? "Add one more shirt and it's free." : c.n + ' custom shirts at the sale price.'; });
    }

    function deliveryText() {
      function d(n) { var x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
      return d(D.deliv.min) + ' – ' + d(D.deliv.max);
    }
    /* buy box (28/09): no Order Summary breakdown - the protection switch, the CTA (renderCTA), a one-line price hint
       from the cheapest variant (same maths as the cart discounts) and the delivery estimate */
    function renderSummary() {
      set('protect', '');  // owner 30/09: shipping protection is offered only in the cart drawer, off by default - never added from the PDP
      var hp = C.hintPrices(VARIANTS.map(function (v) { return v.price; }), R);
      set('hint', hp ? '1 shirt ' + money(hp.one) + ' · 2 shirts ' + money(hp.two) + (hp.twoFree ? ' (Buy 1 Get 1)' : '') + ' · +' + money(R.pers_price) + ' per printed name' : '');
      all('deliv').forEach(function (el) { el.textContent = deliveryText(); });
    }

    function renderCTA() {
      var c = calc();
      var pct = c.full ? Math.round(c.saved / c.full * 100) : 0;
      var cartAmount = c.base - c.disc + c.persFee + c.prot;
      var cartFull = c.base + c.persFee + c.prot;          /* same basis as cartAmount: no shipping */
      var cartPct = cartFull ? Math.round(c.disc / cartFull * 100) : 0;
      var bar = barEl;
      var count = bar ? +bar.getAttribute('data-count') || 0 : 0;
      var active = S.shirts[S.active] || S.shirts[0];
      set('bar-thumb', shot(imgOf(active), null, ''));
      set('bar-l', (bar ? '<b class="rp-bar-title">' + esc(bar.getAttribute('data-title')) + '</b>' : '') +
        (count > 0 ? '<span class="rp-bar-stars">★ ' + esc(bar.getAttribute('data-rating')) + ' <small>(' + count + ')</small></span>' : '') +
        '<span class="rp-row"><b>' + money(cartAmount) + '</b>' + (c.disc > 0 ? '<s>' + money(cartFull) + '</s><span class="rp-pct">Save ' + cartPct + '%</span>' : '') + '</span>');
      var needDesign = DYO && !S.design;
      all('cta').forEach(function (b) {
        b.disabled = S.busy;
        b.className = needDesign ? 'rp-cta rp-todo' : 'rp-cta';
        b.dataset.act = needDesign ? 'design' : 'cart';
        var label = b.dataset.short ? 'Add to Cart' : (c.n > 1 ? 'Add Bundle to Cart' : 'Add to Cart') + ' – ' + money(cartAmount);
        b.innerHTML = S.busy ? 'Adding…' : needDesign ? I_PEN + (b.dataset.short ? 'Design first' : 'Design your shirt first') : I_CART + label;
      });
      all('error').forEach(function (e) { e.textContent = S.error; e.hidden = !S.error; });
    }

    function renderDyo() {
      var el = one('dyo');
      if (!el) return;
      var d = S.design, head = el.getAttribute('data-heading') || '', text = el.getAttribute('data-text') || '';
      if (!d) {
        el.className = 'rp-dyo';
        el.innerHTML = '<h2 class="rp-dyo__h">' + esc(head) + '</h2>' + (text ? '<p class="rp-dyo__p">' + esc(text) + '</p>' : '') +
          (D.images.length ? '<div class="rp-dyo__samples" aria-hidden="true">' + D.images.slice(0, 3).map(function (u) { return '<img src="' + esc(u) + '" alt="" loading="lazy">'; }).join('') + '</div>' : '') +
          '<button type="button" class="rp-dyo__go" data-act="design">' + I_PEN + esc(el.getAttribute('data-button') || 'Start designing') + '</button>';
        return;
      }
      el.className = 'rp-dyo is-chosen';
      el.innerHTML = '<span class="rp-dyo__ok">✓ Your design</span><div class="rp-dyo__pick">' + shot(sized(d.square || d.image, 600), S.shirts[0], 'Your design') +
        '<div><b>' + esc(d.paletteName || '') + ' · ' + esc(d.sku) + '</b>' +
        '<small>Name: ' + esc(d.nameColor.label) + ' · Team name: ' + esc(d.teamColor.label) + '</small>' +
        '<small>Shown on our bowling jersey. ' + (PM.mode === 'style' ? 'We print this design on every style you pick below.' : 'We print this design on every shirt in your order.') + '</small>' +
        '<button type="button" class="rp-dyo__change" data-act="design">' + esc(el.getAttribute('data-change') || 'Change design') + '</button></div></div>';
    }
    function openDesigner() {
      if (!window.__rpDesigner) { S.error = 'The design studio could not load. Please refresh the page and try again.'; renderCTA(); return; }
      var s0 = S.shirts[0];
      document.dispatchEvent(new CustomEvent('rp:design-open', { detail: { name: s0.name, team: s0.team } }));
    }

    function renderAll() { syncWide(); renderGallery(); renderPrice(); renderDyo(); renderOffers(); renderCards(); renderPreview(); renderSummary(); renderCTA(); save(); }
    function renderLive(i) {
      var c = calc(), s = S.shirts[i];
      var ch = scope.querySelector('#rp-ch-' + i), ct = scope.querySelector('#rp-ct-' + i), pf = scope.querySelector('#rp-pfee-' + i);
      if (ch) ch.innerHTML = headHTML(i, c);
      if (pf) pf.textContent = persFeeText(s);
      if (ct) ct.innerHTML = shot(imgOf(s), s, '');
      if (i === 0) renderDyo();
      renderGallery(); renderPreview(); renderSummary(); renderCTA(); save();
    }

    function showToast(count, root) {
      var t = document.getElementById('rp-toast');
      if (!t) {
        t = document.createElement('div');
        t.id = 'rp-toast'; t.className = 'rp-toast'; t.setAttribute('role', 'status'); t.hidden = true;
        document.body.appendChild(t);
        t.addEventListener('click', function (e) { if (e.target.closest('.rp-toast-x')) t.hidden = true; });
      }
      t.innerHTML = '<button type="button" class="rp-toast-x" aria-label="Close">×</button>' +
        '<p><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#17B26A"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4"/></svg>' +
        count + ' shirt' + (count > 1 ? 's' : '') + ' added to your cart</p>' +
        '<div class="rp-toast-actions"><a class="rp-t-secondary" href="' + root + 'cart">View cart</a><a class="rp-t-primary" href="' + root + 'checkout">Checkout</a></div>';
      t.hidden = false;
      clearTimeout(t.__timer);
      t.__timer = setTimeout(function () { t.hidden = true; }, 8000);
    }
    function refreshCartBubble(html) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !html) return;
      var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }

    function designCtx() {
      if (!DYO || !S.design) return {};
      var d = S.design, dark = d.dark || {};
      return { colorway: d.paletteName || d.palette, design: d.sku,
               nameColor: C.textColorLabel(d.nameColor, dark.name), teamColor: C.textColorLabel(d.teamColor, dark.team),
               extra: { 'Design Notes': C.cleanNote(d.idea, 80), _design_image: d.image, _design_style: d.style || '' } };
    }
    function addToCart(trigger) {
      if (DYO && !S.design) { openDesigner(); return; }
      var firstBad = -1;
      S.shirts.forEach(function (s, i) { if (firstBad < 0 && missing(s)) firstBad = i; });
      if (firstBad >= 0) {
        S.showErrors = true; S.error = '';
        renderAll();
        var el = scope.querySelector('#rp-card-' + firstBad);
        if (el) el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { var b = scope.querySelector('#rp-size-' + firstBad + ' .rp-sz:not([disabled])'); if (b) b.focus({ preventScroll: true }); }, 350);
        return;
      }
      var picked = S.shirts.map(function (s) { var v = variantOf(s); return { variantId: v.id, pers: s.pers, name: s.name, team: s.team }; });
      S.busy = true; S.error = ''; renderCTA();
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var protInCart = cart.items.some(function (it) { return it.variant_id === D.fees.protection.variant_id; });
          var ctx = designCtx();
          if (ICON && !(LIB && LIB.noIcon)) ctx.chestIcon = ICON.label + ' icon above the name';
          ctx.bundleId = C.bundleId(Date.now()); ctx.persVariant = D.fees.personalization.variant_id;
          ctx.protVariant = D.fees.protection.variant_id; ctx.protect = S.protect; ctx.protInCart = protInCart;
          var items = C.buildItems(picked, ctx);
          var body = { items: items, sections: 'cart-drawer,cart-icon-bubble' };
          return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
            .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); });
        })
        .then(function (out) {
          if (!out.ok || out.data.status) throw new Error(out.data.description || out.data.message || 'Could not add to cart');
          S.busy = false; S.showErrors = false; renderCTA();
          /* spec: confirm lightly, keep the shopper on the page, don't force the cart open unless cart_type is drawer */
          var drawer = document.querySelector('cart-drawer');
          var rendered = false;
          if (drawer && typeof drawer.renderContents === 'function') {
            try {
              /* mirrors Dawn's product-form.js: clear is-empty before renderContents, or the header + items
                 stay hidden under the empty-cart CSS after adding from an initially-empty cart */
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              /* mirrors product-form.js: Esc/close returns focus to the CTA that added */
              if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger || all('cta')[0]);
              drawer.renderContents({ id: D.product.id, sections: out.data.sections });
              rendered = true;
            } catch (e) {
              if (window.console) console.error('[rp-bundle] drawer render', e);
            }
          }
          if (!rendered) {
            refreshCartBubble(out.data.sections && out.data.sections['cart-icon-bubble']);
            showToast(S.shirts.length, base);
          }
        })
        .catch(function (e) {
          S.busy = false;
          S.error = "Sorry, we couldn't add your shirts" + (e && e.message ? ': ' + e.message : '') + '. Please try again.';
          renderCTA();
        });
    }

    function setCount(n) {
      n = Math.max(1, Math.min(R.max, n));
      var f = S.shirts[0];
      while (S.shirts.length < n) S.shirts.push({ style: f.style, color: f.color, size: '', pers: true, name: '', team: f.team });
      S.shirts.length = n;
      if (S.active >= n) S.active = n - 1;
    }
    function goTo(i) {
      S.active = i; S.view = 0; renderAll();
      var el = scope.querySelector('#rp-card-' + i);
      if (el) el.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      setTimeout(function () { var b = scope.querySelector('#rp-size-' + i + ' .rp-sz:not([disabled])'); if (b) b.focus({ preventScroll: true }); }, 300);
    }

    function openLightbox() {
      var img = scope.querySelector('[data-rp=gal] img');
      if (!img) return;
      var box = document.getElementById('rp-lightbox');
      if (!box) {
        box = document.createElement('div');
        box.id = 'rp-lightbox'; box.className = 'rp-lightbox'; box.hidden = true;
        box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Product image');
        box.innerHTML = '<img alt=""><button type="button" aria-label="Close">×</button>';
        document.body.appendChild(box);
        var close = function () { box.hidden = true; };
        box.addEventListener('click', function (e) { if (e.target === box || e.target.closest('button')) close(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
      }
      box.querySelector('img').src = img.src.replace(/([?&])width=\d+/, '$1width=2000');
      box.querySelector('img').alt = img.alt;
      box.hidden = false;
      box.querySelector('button').focus();
    }

    function onClick(e) {
      if (Date.now() < (S.lockUntil || 0)) return;  // the 2nd click of a double-click on "Use this design" lands here
      if (e.target.closest('[data-rp=gal]')) { if (Date.now() - (S.swipedAt || 0) > 400) openLightbox(); return; }
      var b = e.target.closest('[data-act]');
      if (!b || !e.currentTarget.contains(b) || !b.closest('.rp-bundle') || b.tagName === 'SELECT' || b.type === 'checkbox') return;
      var i = +b.dataset.i;
      switch (b.dataset.act) {
        case 'view': S.view = +b.dataset.v; renderGallery(); break;
        case 'step': { var n = Math.max(1, galleryOf(S.shirts[S.active] || S.shirts[0]).length); S.view = ((S.view || 0) + (+b.dataset.v) + n) % n; renderGallery(); break; }
        case 'size': { S.shirts[i].size = b.dataset.v; S.active = i; S.view = 0; renderAll(); var x = scope.querySelector('#rp-size-' + i + ' [data-v="' + b.dataset.v + '"]'); if (x) x.focus({ preventScroll: true }); break; }
        case 'teamcolor': S.shirts.forEach(function (s) { s.color = b.dataset.v; }); S.view = 0; renderAll(); break;
        case 'tier': setCount(+b.dataset.n); renderAll(); break;
        case 'focus': S.active = i; S.view = 0; renderGallery(); break;
        case 'copy': { var s0 = S.shirts[0]; S.shirts[i].style = s0.style; S.shirts[i].color = s0.color; S.shirts[i].size = s0.size; S.shirts[i].team = s0.team; renderAll(); break; }
        case 'remove': S.shirts.splice(i, 1); S.active = Math.min(S.active, S.shirts.length - 1); renderAll(); break;
        case 'add': { var first = S.shirts.length; setCount(first + (+b.dataset.n || 1)); goTo(Math.min(first, S.shirts.length - 1)); break; }
        case 'fix': goTo(i); break;
        case 'edit': { var bd = one('bundle'); if (bd) bd.scrollIntoView({ behavior: 'smooth', block: 'start' }); break; }
        case 'cart': if (!S.busy) addToCart(b); break;
        case 'design': openDesigner(); break;
      }
    }
    /* the design studio hands back the chosen design (see rp-designer.js use()) */
    document.addEventListener('rp:design', function (e) {
      var d = e.detail;
      if (!DYO || !validDesign(d)) return;
      S.design = d;
      S.lockUntil = Date.now() + 700;
      var opened = d.opened || {};
      C.applyStudioText(S.shirts, { name: C.sanitize(opened.name, C.NAME_MAX), team: C.sanitize(opened.team, C.TEAM_MAX) },
                        { name: C.sanitize(d.name, C.NAME_MAX), team: C.sanitize(d.team, C.TEAM_MAX) });
      S.active = 0; S.view = 0; S.error = '';
      renderAll();
      var change = scope.querySelector('[data-rp=dyo] .rp-dyo__change');
      if (change) change.focus({ preventScroll: true });
      var next = one('offers') || one('cards');
      var blk = next && next.closest('.rp-block');
      if (blk) setTimeout(function () { blk.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); }, 50);
    });
    ROOTS.forEach(function (r) { r.addEventListener('click', onClick); });

    /* swipe (touch) or drag (mouse) the main photo sideways to change photos - no arrow buttons.
       touch-action: pan-y keeps vertical page scrolling with the browser. */
    (function () {
      var main = scope.querySelector('.rp-gal-main');
      if (!main) return;
      var drag = null;
      main.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag = { x: e.clientX, y: e.clientY, id: e.pointerId, dx: 0, horiz: null };
      });
      main.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (drag.horiz === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
          drag.horiz = Math.abs(dx) > Math.abs(dy);
          if (drag.horiz) { try { main.setPointerCapture(e.pointerId); } catch (err) {} main.classList.add('rp-dragging'); }
        }
        if (drag.horiz) { drag.dx = dx; var g = one('gal'); if (g) g.style.transform = 'translateX(' + dx + 'px)'; }
      });
      function end(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var d = drag; drag = null;
        main.classList.remove('rp-dragging');
        var g = one('gal'); if (g) g.style.transform = '';
        if (!d.horiz) return;
        S.swipedAt = Date.now();
        var n = galleryOf(S.shirts[S.active] || S.shirts[0]).length;
        if (n < 2 || Math.abs(d.dx) < Math.max(40, main.clientWidth * 0.12)) return;  // short pull: spring back
        var dir = d.dx < 0 ? 1 : -1;  // pulled left -> next photo
        S.view = ((S.view || 0) + dir + n) % n;
        renderGallery(dir);
      }
      main.addEventListener('pointerup', end);
      main.addEventListener('pointercancel', end);
    })();
    scope.addEventListener('change', function (e) {
      var t = e.target, i = +t.dataset.i;
      if (!t.closest || !t.closest('.rp-bundle')) return;
      if (t.dataset.act === 'style') { S.shirts[i].style = t.value; S.active = i; S.view = 0; renderAll(); }
      if (t.dataset.act === 'color') { S.shirts[i].color = t.value; S.active = i; S.view = 0; renderAll(); }
      if (t.dataset.act === 'pers') { S.shirts[i].pers = t.checked; S.active = i; renderAll(); }
      if (t.dataset.act === 'protect') { S.protect = t.checked; renderSummary(); renderCTA(); save(); }
    });
    function onText(t, rewrite) {
      if (t.dataset.act !== 'name' && t.dataset.act !== 'team') return;
      var i = +t.dataset.i, v = C.sanitize(t.value, t.dataset.act === 'name' ? C.NAME_MAX : C.TEAM_MAX);
      if (rewrite && t.value !== v) t.value = v;
      S.shirts[i][t.dataset.act] = v; S.active = i; S.view = 0; renderLive(i);
    }
    scope.addEventListener('input', function (e) { onText(e.target, !e.isComposing); });
    scope.addEventListener('compositionend', function (e) { onText(e.target, true); });
    scope.addEventListener('focusin', function (e) {
      var t = e.target;
      if (t.closest && t.closest('.rp-bundle') && t.dataset && t.dataset.i !== undefined && S.active !== +t.dataset.i) { S.active = +t.dataset.i; S.view = 0; renderGallery(); }
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { S.busy = false; S.error = ''; renderCTA(); } });

    document.body.classList.add('rp-has-bar');
    renderAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
